//console.log('rebuy-cart-preorder')
function initRebuyCartPreorder(cart){
	//console.log('initRebuyCartPreorder')
  //const cartRes = await fetch(`${window.location.origin}/cart.js`);
  //const cart = await cartRes.json();
  //console.log('cart')
  //console.log(cart.items)
  // console.log(cart.items[0].product_id)

	removeLabels();

	cart.items.forEach( (item, i) => {
		getAndLabel(item, i);
	})

	async function getAndLabel(item, i){
		const product = await getProductMetafields(item.product_id.toString());
		//console.log('------------product')
		//console.log(product)
		addLabel(i, product.data.product, item.variant_id);
	}

	function getProductMetafields(pid){
		return new Promise((resolve) => {
			const query =  `query getProductById($id: ID!) {
				product(id: $id) {
					title,
					metafields(identifiers: [ 
					{namespace: "product", key: "subtitle"}
					]) { 
					type 
					namespace 
					key 
					}
					variants(first: 50) {
						edges {
							node {
								id
								sku
								metafields(identifiers: [ 
								{namespace: "pre_order", key: "date"}
								
								]) {
								value
								type 
								namespace 
								key 
								}
							}
						}
					}
				}
			}`

			fetch('https://stylest.com/api/graphql', {
				method: "POST",
				headers: {
					"X-Shopify-Storefront-Access-Token":"29cb06d9d4d2298efaa098df451afec4",
				"Content-Type": "application/json",
					"Accept": "application/json"
				},
				body: JSON.stringify({ 
					query: query,
					variables: {
						id: `gid://shopify/Product/${pid}`,
					}
				})
			}).then(res => {
				return res.json();  
			}).then(data => {
				resolve(data)
			}).catch(err => {
				console.log(err)
			})
		});
	}    

	function removeLabels(){
		let items = Array.from(document.getElementsByClassName('rebuy-cart__flyout-item'));
		items.forEach( item => {
			Array.from(item.getElementsByClassName('preorder-cart-label')).forEach( label => {
				label.remove();
			})
		})
	}

	function addLabel(i, product, vid){
		const variant = product?.variants.edges.find(v => v.node.id.indexOf(vid) > -1);
		if(variant?.node.metafields[0] != null){
			if(document.getElementsByClassName('rebuy-cart__flyout-items').length > 0){
				let items = Array.from(document.getElementsByClassName('rebuy-cart__flyout-item'));
				let label = document.createElement("div");
				label.classList.add('preorder-cart-label');
				//label.innerHTML = `Pre-order: test ${i}`;
				label.innerHTML = `Pre-order: ${variant.node.metafields[0].value}`;
				items[i].getElementsByClassName('rebuy-cart__flyout-item-product-title')[0].insertAdjacentElement("afterend", label)
			}
		}
	}

}

//initRebuyCartPreorder(event.detail.cart.cart);

document.addEventListener('rebuy:cart.change', (event) => { 
  //console.log('----rebuy:cart.change event', event.detail); 
	initRebuyCartPreorder(event.detail.cart.cart)
});